/**
 * Brand names (docs/neoprof/brand/IDENTITY.md). Every app = "Neo" + suffix
 * (+ optional lower-case modifier). The company name stays `SITE_BRAND` (constants/site.js).
 */
export const BRAND_PREFIX = 'Neo';

export const APP_BRAND = Object.freeze({
  PROF: { suffix: 'Prof' },
  FAMILY: { suffix: 'Family' },
  LEARN: { suffix: 'Learn' },
  CALCUL: { suffix: 'Calcul' },
  SCRATCH: { suffix: 'Scratch' },
  PLAYLIST: { suffix: 'Playlist' },
  EXAM: { suffix: 'Exam' },
  BREVET: { suffix: 'Brevet' },
  BAC: { suffix: 'Bac' },
  BAC_PREMIERE: { suffix: 'BacPremiere' },
  DEFI: { suffix: 'Defi' },
  DEFI_EXPRESS: { suffix: 'Defi', modifier: 'express' },
  TEST: { suffix: 'Test' },
  MISSION: { suffix: 'Mission' },
  STORY: { suffix: 'Story' },
});

/** Plain-text name for titles, SEO, aria-labels: `NeoDefi express`. */
export function appBrandText(app) {
  const { suffix, modifier } = APP_BRAND[app] || APP_BRAND.PROF;
  return modifier ? `${BRAND_PREFIX}${suffix} ${modifier}` : `${BRAND_PREFIX}${suffix}`;
}

/** Sizes: wordmark font 16 · 22 · 32 · 48 px; icon box 16 · 32 · 48 · 120 px. SM = 2-tone Néo. */
export const BRAND_SIZE = Object.freeze({ SM: 'sm', MD: 'md', LG: 'lg', XL: 'xl' });
export const BRAND_MONO_SIZES = Object.freeze([BRAND_SIZE.SM]);

/**
 * Logo image files under public/brand, written by `scripts/export-brand-assets.js`
 * from `BrandMarkArtwork`. Wordmark: `<app>-<tone>[-mono]`; icons: fixed names.
 */
export const BRAND_ASSET_DIR = '/brand/';
export const BRAND_ICON = Object.freeze({ FULL: 'icon', MONO: 'icon-16', XL: 'icon-xl' });
export const brandAssetName = (app, tone = 'light', mono = false) => (
  `${app.toLowerCase().replace(/_/g, '-')}-${tone}${mono ? '-mono' : ''}`);
export const brandAssetUrl = (name, extension = 'svg') => `${BRAND_ASSET_DIR}${name}.${extension}`;
/** Raster copies for documents (PDF, e-mail, exported files), 4× the 48 px wordmark. */
export const BRAND_PNG = Object.freeze({ PROF: 'prof-light@4x', PROF_DARK: 'prof-dark@4x', MISSION: 'mission-light@4x' });
